import React, { useEffect, useState, useContext } from "react";
import { useAlert } from 'react-alert';
import { useNavigate } from "react-router-dom";

import PlaceholderCardLayout from "../layout_components/PlaceholderCardLayout";
import Button from "../common_components/Button";
import { TextInput, SelectInput } from "../common_components/Forms";
import IsValidEVMAddress from "../../../../utility_components/IsValidAddress";

// API Calls
import CashOutAPI from "../../api/api_calls/CashOutAPI";


function AddPayoutCard({ refreshPayouts, setRefreshPayouts, balance, requestedTotal, showRequestPayout, setShowRequestPayout, ...props }) {
    const navigate = useNavigate();
    const alert = useAlert();

    // --------------------------------------------
    // ----------------Form Logic---------------
    // --------------------------------------------

    const [amount, setAmount] = useState("");
    const [blockchain, setBlockchain] = useState("Polygon");
    const [walletAddress, setWalletAddress] = useState("");
    const [confirmWalletAddress, setConfirmWalletAddress] = useState("");

    // Error messages
    const [amountError, setAmountError] = useState(null);

    const availableBalance = balance && requestedTotal ? ((balance) - requestedTotal).toFixed(2) : balance;

    const blockchainOptions = [
        { label: "Polygon", value: "Polygon" },
        { label: "Ethereum", value: "Ethereum" },
    ]

    async function createCashOut() {
        const response = await CashOutAPI.create(walletAddress, amount, blockchain, navigate)

        if (response.success) {
            alert.show("Payout request created",
                { type: 'success' })
            navigate(0)
        } else {
            alert.show("Unable to create payout request. Try again later or contact info@despark.io",
                { type: 'error' })
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Amount: ", amount)
        console.log("Blockchain: ", blockchain)
        console.log("Wallet Address: ", walletAddress)
        console.log("Confirm Wallet Address: ", confirmWalletAddress)

        if (amount == "" || blockchain == "" || walletAddress == "" || confirmWalletAddress == "") {
            alert.show("Please fill out all fields",
                { type: 'error' })
            return;
        }

        if (amountError) {
            alert.show(amountError,
                { type: 'error' })
            return;
        }

        // Make sure payout amount is less than user's balance 
        // Vetted on back end as well.
        if (parseFloat(amount) > parseFloat(availableBalance)) {
            alert.show("Request cannot be larger than available balance. You may already have a payout request pending.",
                { type: 'error' })
            return;
        }

        // Minimum withdrawal amount is $10 
        // Also covers the field being blank
        if (amount < 10 && blockchain == "Ethereum") {
            alert.show("Minimum Ethereum payout is $10",
                { type: 'error' })
            return;
        }

        // Make sure eth address matches confirmed eth address
        if (walletAddress != confirmWalletAddress) {
            alert.show("Wallet addresses do not match",
                { type: 'error' })
            return;
        }

        // Make sure eth address is valid
        if (IsValidEVMAddress(walletAddress) == false) {
            alert.show("Not a valid wallet address",
                { type: 'error' })
            return;
        }

        createCashOut();
    }

    // --------------------------------------------
    // ----------------Helper Functions---------------
    // --------------------------------------------

    function updateAmount(newAmount) {
        // Vet that it is a number
        if (isNaN(newAmount)) {
            setAmountError("Please enter a valid number");
            return;
        }

        // Vet that it has a maximum of 2 decimal places
        if (newAmount.includes(".")) {
            const decimalPlaces = newAmount.split(".")[1].length;
            if (decimalPlaces > 2) {
                setAmountError("Maximum 2 decimal places");
                return;
            }
        }
        // Minimum withdrawal amount is $10 
        if (newAmount < 10 && blockchain == "Ethereum") {
            setAmountError("Minimum payout is $10 for Ethereum. Change the network or amount.");
        } else {
            setAmountError(null);
        }
        setAmount(newAmount);
    }

    function updateBlockchain(newBlockchain) {
        setBlockchain(newBlockchain);
        if (amount < 10 && newBlockchain == "Ethereum") {
            setAmountError("Minimum payout is $10 for Ethereum. Change the network or amount.");
        } else {
            setAmountError(null);
        }
    }




    // --------------------------------------------
    // ----------------Render Logic---------------
    // --------------------------------------------


    return (
        <PlaceholderCardLayout>
            <form className="payout-card-container" onSubmit={handleSubmit}>
                <div className="payout-card-title-and-subtitle-container">
                    <h1 className="h1-card-text">Request a payout</h1>
                    <div className="body-small black-500-text">
                        Payments will be made in USDC on the specified blockchain. Please allow up to 7 days for processing.
                    </div>
                </div>
                <div className="user-input-container">
                    <div className="payout-label-text" >Available balance</div>
                    <div className="payout-value-text" >${availableBalance}</div>
                </div>
                <div className="amount-input-wrapper">
                    <TextInput
                        label="Amount (USDC)"
                        name="amount"
                        placeholder="5.00"
                        error={amountError}
                        onChange={(e) => updateAmount(e.target.value)}
                        value={amount}
                    />
                    <button
                        type="button"
                        className="max-button body-tiny"
                        onClick={() => updateAmount(availableBalance)}
                    >
                        Max
                    </button>
                </div>
                <SelectInput label="Network" name="blockchain" value={blockchain} options={blockchainOptions} onChange={(e) => updateBlockchain(e.target.value)} />
                <TextInput label="Wallet Address" name="walletAddress" placeholder="0x4e9ce36E44..." onChange={(e) => setWalletAddress(e.target.value)} />
                <TextInput label="Confirm Wallet Address" name="confirmWalletAddress" placeholder="0x4e9ce36E44..." onChange={(e) => setConfirmWalletAddress(e.target.value)} />
                <Button size="large" color="primary" fullWidth={true} type="submit">Send request</Button>
            </form>
        </PlaceholderCardLayout>
    )
}

export default AddPayoutCard